import React, { useEffect, useState } from "react";
import Rightbar from "../../Rightbar/Rightbar";
import Table from "../../Table/Table";
import Tabswitch from "../../Tabswitch/Tabswitch";
import {
  admin_ts_get,
  admin_ts_post,
  custom_patch,
  get,
  patch,
  post,
} from "../../../../utils/api";
import ListHeader from "./ListHeader";
import "./invoiceRightbarData";
import {
  InvoiceRightbarHeader,
  InvoiceRightbarBody,
  InvoiceRightbarSubBody,
  InvoiceRightbarFooter,
} from "./invoiceRightbarData";
import RestaurantChainModal from "./RestaurantChainModal";

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

export default function ListModule(props: any) {
  let id = props.primary_id;
  const pathname = window.location.pathname;
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const [data, setData] = useState<Array<any>>([]);
  const [checked, setChecked] = useState<Array<any>>([]);
  const [checkedCities, setCheckedCities] = useState<Array<any>>([]);
  const [checkedRestaurants, setCheckedRestaurants] = useState<Array<any>>([]);
  const [isHeaderChecked, setIsHeaderChecked] = useState(false);
  const [selectedInvoiceData, setSelectedInvoiceData] = useState<any>({});
  const [invoiceDetails, setInvoiceDetails] = useState<any>({});
  const [invoiceSidebarStatus, setInvoiceSidebarStatus] = useState(false);
  const [sortBy, setSortBy] = useState<any>(
    props.sortBy ? props.sortBy : { _id: -1 }
  );
  const [financialYear, setFinancialYear] = useState<any>([]);

  const [columns, setColumns] = useState<Array<String>>([]);
  const [columnFields, setColumnFields] = useState<Array<any>>([]);
  const [filterData, setFilterData] = useState<any>([]);
  const [fieldsMaster, setFieldsMaster] = useState<Array<any>>([]);
  const [detailViewModal, setDetailViewModal] = useState({
    status: false,
    id: "",
  });

  const [isListView, setIsListView] = useState(false);

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  useEffect(() => {
    getData();
    // getInvoiceDetails();
    // getFYData();
  }, [page, rowsPerPage, filterData, sortBy]);

  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    const nextPage = newPage + 1;
    setPage(nextPage);
  };

  const handleDownload = () => {
    let params = {
      page: page,
      limit: rowsPerPage,
      filter: filterData,
      sortBy: sortBy,
    };

    get(`${props.module}/pathToYourDownload`, params)
      .then((res) => {
        const encoder = new TextEncoder();
        const encodedData = encoder.encode(res.data);
        const decoder = new TextDecoder("utf-8");
        const decodedData = decoder.decode(encodedData);
        const blob = new Blob([decodedData], {
          type: "text/csv;charset=utf-8",
        });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "data.csv");
        link.click();
        setChecked([]);
        setIsHeaderChecked(false);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const handleRestaurantChain = async (e: any) => {
    handleOpen();
    // const newData = {
    //   city_id: 553,
    //   restaurant_ids: e.restaurantIds,
    //   chain_name: e.restaurant_name,
    // };
    // try {
    //   const response = await admin_ts_post("restaurantChain", newData);
    //   if (response) {
    //     console.log(response);
    //     // const restaurantResponse = await patch(
    //     //   "restaurants" + restaurant_id,
    //     //   restaurant_data
    //     // );
    //   }
    // } catch (error) {
    //   console.log(error);
    // }
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(1);
  };

  const handleChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    setFinancialYear(event.target.value as number);
  };

  let tabData = [
    {
      tabName: "Invoice Details",
      tabLink: "#",
    },
    {
      tabName: "Purchase Details",
      tabLink: "#",
    },
  ];

  const getData = () => {
    let params: any = {
      page: page,
      limit: rowsPerPage,
      filter: filterData,
      sortBy: sortBy,
    };

    get(`${props.module}`, params)
      .then(async (response) => {
        console.log("tttttttt", response.data);
        await setData(response.data.data);
        await setTotalCount(response.data.totalCount);
        await setFieldsMaster(response.data.fields);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const handleFieldStatus = (cindex: any) => {
    const columnsFields = fieldsMaster.map((e: any, index: number) => {
      return {
        ...e,
        coloumn_status: cindex === index ? !e.coloumn_status : e.coloumn_status,
      };
    });
    setFieldsMaster(columnsFields);
  };

  const getInvoiceDetails = (id: any) => {
    get(`${props.module}/${id}`, {}).then((response) => {
      setInvoiceDetails(response.data);
    });
  };

  const handleSortBy = async (key: string) => {
    if (sortBy[key] == 1) {
      let sortData = { [key]: -1 };
      await setSortBy(sortData);
    } else {
      let sortData = { [key]: 1 };
      await setSortBy(sortData);
    }
  };

  const handleUpdate = async (data: any) => {
    let newData = data;
    post(`${props.module}/updateMultiple`, {
      ids: checked,
      updateData: newData,
    })
      .then((res) => {
        setChecked([]);
        setIsHeaderChecked(false);
        getData();
        updateAdminActivity(checked, props.module, newData);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const updateAdminActivity = (ids: any, module: any, newData: any) => {
    custom_patch(`adminActivities`, {
      ids: ids,
      module: module,
      updateData: newData,
    })
      .then((res: any) => {
        console.log(res);
      })
      .catch(function (error: any) {
        console.log(error);
      });
  };

  const handleListView = () => {
    setIsListView(true);
  };

  const handleCardView = () => {
    setIsListView(false);
  };

  const showRightSidebar = (data: any) => {
    setInvoiceSidebarStatus(data.status);
    setSelectedInvoiceData(data.data);
    getInvoiceDetails(data.data.invoice_no);
  };

  const handleClick = (e: any) => {
    props.drawerClick(e);
  };

  return (
    <div className="row">
      <div className="col-xs-12">
        {pathname.includes("/sales/invoices") && (
          <Rightbar
            status={invoiceSidebarStatus}
            showRightSidebar={setInvoiceSidebarStatus}
            headingContent={
              <InvoiceRightbarHeader headerData={selectedInvoiceData} />
            }
            tabContent={
              <Tabswitch tabData={tabData} style={{ color: "#FFF" }} />
            }
            bodyContent={
              <InvoiceRightbarBody currentInvoiceDetails={setInvoiceDetails} />
            }
            bodySubContent={<InvoiceRightbarSubBody />}
            footerContent={<InvoiceRightbarFooter />}
            invoiceDetails={invoiceDetails}
          />
        )}
        <ListHeader
          totalCount={totalCount}
          fieldsMaster={fieldsMaster}
          module={props.module}
          modulePath={props.modulePath}
          getData={getData}
          id={props.id}
          filterData={filterData}
          setFilterData={setFilterData}
          page={page}
          rowsPerPage={rowsPerPage}
          setRowsPerPage={setRowsPerPage}
          handleChangePage={handleChangePage}
          handleChangeRowsPerPage={handleChangeRowsPerPage}
          financialYear={financialYear}
          handleChange={handleChange}
          handleUpdate={handleUpdate}
          handleDownload={handleDownload}
          handleRestaurantChain={handleRestaurantChain}
          moduleId={`${props.module}_id`}
          handleListView={handleListView}
          handleCardView={handleCardView}
          filterType={props.filterType}
        />

        <Table
          data={data}
          module={props.module}
          detailLink={props.modulePath + "/details/"}
          editLink={props.modulePath + "/edit/"}
          columns={columns}
          checked={checked}
          checkedCities={checkedCities}
          setCheckedCities={setCheckedCities}
          checkedRestaurants={checkedRestaurants}
          setCheckedRestaurants={setCheckedRestaurants}
          setChecked={setChecked}
          getData={getData}
          isHeaderChecked={isHeaderChecked}
          setIsHeaderChecked={setIsHeaderChecked}
          showRightSidebar={showRightSidebar}
          // setDetailViewModal={setDetailViewModal}
          rightSidebarStatus={invoiceSidebarStatus}
          primary_id={props.primary_id}
          fields={fieldsMaster}
          handleFieldStatus={handleFieldStatus}
          sortBy={sortBy}
          handleSortBy={handleSortBy}
          isListView={isListView}
          setIsListView={setIsListView}
          filterType={props.filterType}
        />

        <RestaurantChainModal
          open={open}
          handleClose={handleClose}
          style={style}
          checked={checked}
          setChecked={setChecked}
          checkedCities={checkedCities}
          setCheckedCities={setCheckedCities}
          checkedRestaurants={checkedRestaurants}
          setCheckedRestaurants={setCheckedRestaurants}
          getData={getData}
          isHeaderChecked={isHeaderChecked}
          setIsHeaderChecked={setIsHeaderChecked}
        />

        {/* <DetailViewModal
          detailsModule={props.detailsModule}
          detailViewModal={detailViewModal}
          setDetailViewModal={setDetailViewModal}
        /> */}
      </div>
    </div>
  );
}
